/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreditCardGetResponseFromDiscriminatorValue, serializeCreateCreditCardRequest, type CreateCreditCardRequest, type CreditCardGetResponse } from '../models';
// @ts-ignore
import { HistoryRequestBuilderNavigationMetadata, type HistoryRequestBuilder } from './history';
// @ts-ignore
import { type WithCreditCardItemRequestBuilder, WithCreditCardItemRequestBuilderNavigationMetadata, WithCreditCardItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { OverviewRequestBuilderRequestsMetadata, type OverviewRequestBuilder } from './overview';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /creditcards
 */
export interface CreditcardsRequestBuilder extends BaseRequestBuilder<CreditcardsRequestBuilder> {
    /**
     * The history property
     */
    get history(): HistoryRequestBuilder;
    /**
     * The overview property
     */
    get overview(): OverviewRequestBuilder;
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.creditcards.item collection
     * @param creditCardId The Guid identifier of the credit card to retrieve
     * @returns {WithCreditCardItemRequestBuilder}
     */
     byCreditCardId(creditCardId: Guid) : WithCreditCardItemRequestBuilder;
    /**
     * Retrieves a list of all credit cards
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreditCardGetResponse[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreditCardGetResponse[] | undefined>;
    /**
     * Creates a new credit card
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     */
     post(body: CreateCreditCardRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * Retrieves a list of all credit cards
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Creates a new credit card
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateCreditCardRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CreditcardsRequestBuilderUriTemplate = "{+baseurl}/creditcards";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CreditcardsRequestBuilderNavigationMetadata: Record<Exclude<keyof CreditcardsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCreditCardId: {
        requestsMetadata: WithCreditCardItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithCreditCardItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["creditCardId"],
    },
    history: {
        navigationMetadata: HistoryRequestBuilderNavigationMetadata,
    },
    overview: {
        requestsMetadata: OverviewRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CreditcardsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CreditcardsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCreditCardGetResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: CreditcardsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateCreditCardRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
